import { baseURLAdmin, commonHeaderAdmin } from "./constants";

export async function fetchDataCarCompaniesApi() {
  return fetch(
    `${baseURLAdmin}/data-registry/attribute/default/carCompanyValueMe?limit=1000`,
    {
      method: "GET",
      ...commonHeaderAdmin,
    }
  )
    .then((res) => res.json())
    .catch((error) => {
      return { error: true, ...error };
    });
}
